import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/apps',
    component: LayoutContainer,
    redirect: '/apps/table',
    children: [
      {
        path: 'table',
        name: 'AppTable',
        component: () => import('@/views/System/AppTable.vue'),
        meta: {
          title: '资源管理'
        }
      },
      {
        path: 'org/table',
        name: 'AppOrgTable',
        component: () => import('@/views/System/AppOrgTable.vue'),
        meta: {
          title: '单位资源管理'
        }
      },
    ]
  },
  {
    path: '/roles',
    component: LayoutContainer,
    redirect: '/roles/table',
    children: [
      {
        path: 'table',
        name: 'RoleTable',
        component: () => import('@/views/System/RoleTable.vue'),
        meta: {
          title: '角色管理'
        }
      },
    ]
  },
  {
    path: '/modules',
    component: LayoutContainer,
    redirect: '/modules/table',
    children: [
      {
        path: 'table',
        name: 'ModuleTable',
        component: () => import('@/views/System/ModuleTable.vue'),
        meta: {
          title: '模块管理'
        }
      },
      {
        path: 'module-registration',
        name: "ModuleRegistration",
        component: () => import('@/views/System/ModuleRegistration.vue'),
        meta: {
          title: '单位注册模块管理'
        }
      },
      {
        path: 'org/table',
        name: 'OrgModuleTable',
        component: () => import('@/views/System/OrgModuleTable.vue'),
        meta: {
          title: '单位模块管理'
        }
      },
      {
        path: 'org/module-registration',
        name: "OrgModuleRegistration",
        component: () => import('@/views/System/OrgModuleRegistration.vue'),
        meta: {
          title: '单位内部注册模块管理'
        }
      },
    ]
  },
  {
    path: '/user',
    component: LayoutContainer,
    redirect: '/user/table',
    children: [
      {
        path: 'table',
        name: 'UserTable',
        component: () => import('@/views/System/UserTable.vue'),
        meta: {
          title: '用户管理'
        }
      }
    ]
  },
  {
    path: '/organization',
    component: LayoutContainer,
    redirect: '/organization/index',
    children: [
      {
        path: 'index',
        name: 'OrganizationIndex',
        component: () => import('@/views/System/OrganizationTable.vue'),
        meta: {
          title: '机构管理'
        }
      }
    ]
  },
  {
    path: '/department',
    component: LayoutContainer,
    redirect: '/department/index',
    children: [
      {
        path: 'index',
        name: 'DepartmentIndex',
        component: () => import('@/views/System/DepartmentTable.vue'),
        meta: {
          title: '部门管理'
        }
      }
    ]
  }
]

export default createRouter(routes);